import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import DrawingTemplete from "../layout/templete/DrawingTemplete";
import AddTemplete from "../layout/templete/AddTemplete";
const TempletesPage = () => {
    useEffect(() => {
        return() =>{
            localStorage.removeItem("selectedId")
            localStorage.removeItem("itemOffset")
            localStorage.removeItem("forcePage")
        }
    }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<DrawingTemplete />} />
        <Route path="/add" element={<AddTemplete />} />
        <Route path="/update/:id" element={<AddTemplete />} />
      </Routes>
    </>
  );
};

export default TempletesPage;
